import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState, User, Agency } from "./types";

const initialState: AuthState = {
  access: null,
  refresh: null,
  user: null,
  activeAgency: null,
  permissions: [],
  meLoaded: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTokens(state, action: PayloadAction<{ access: string; refresh: string }>) {
      state.access = action.payload.access;
      state.refresh = action.payload.refresh;
    },
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload;
    },
    setMe(state, action: PayloadAction<{ user: User; activeAgency: Agency | null; permissions: string[] }>) {
      state.user = action.payload.user;
      state.activeAgency = action.payload.activeAgency;
      state.permissions = action.payload.permissions;
      state.meLoaded = true;
    },
    setMeLoaded(state, action: PayloadAction<boolean>) {
      state.meLoaded = action.payload;
    },
    logout(state) {
      state.access = null;
      state.refresh = null;
      state.user = null;
      state.activeAgency = null;
      state.permissions = [];
      state.meLoaded = false;
    },
  },
});

export const { setTokens, setUser, setMe, setMeLoaded, logout } = authSlice.actions;
export default authSlice.reducer;
